var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { get } from "lodash";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import notify from "@irati/utils/notify";
import DealRedemptionList, { getRedemptionList, removeFromRedemptionList } from "@irati/deals/apollo/query/DealRedemptionList";
import redemptionsService from "@irati/deals/services/dealRedemption";
import { getQuery } from "@irati/utils/history";
import { H1, Body } from "@irati/ui/src/Typography";
import { Hr } from "@irati/ui/src/Layout";
import MyPerksItem from "../MyPerksItem";
import NoPerks from "../NoPerks";
import PerkSummaryPopup from "../PerkSummaryPopup";
import MarkPerkAsUsedPopup from "../MarkPerkAsUsedPopup";
import RedemptionHeaders from "./Headers";
import ShowMoreOrThatsAll from "../../DealList/ShowMoreOrThatsAll";
var MyPerksList = /** @class */ (function (_super) {
    __extends(MyPerksList, _super);
    function MyPerksList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showRedemptionPopup: false,
            selectedRedemption: null
        };
        /**
         * Show popup and select redemption
         * @param uuid
         */
        _this.viewRedemption = function (redemption) {
            _this.setState({
                showRedemptionPopup: true,
                selectedRedemption: redemption
            });
        };
        _this.handleMarkAsUsedPopup = function (redemption) {
            if (redemption.isUsed) {
                _this.handleToggleIsUsed(redemption);
            }
            else {
                _this.setState({
                    selectedRedemption: redemption
                });
            }
        };
        _this.handleClose = function () {
            _this.setState({ selectedRedemption: null, showRedemptionPopup: false });
        };
        _this.handleToggleIsUsed = function (redemption) {
            var formatMessage = _this.props.formatMessage;
            removeFromRedemptionList(redemption, _this.variables);
            return redemptionsService.toggleIsUsed(redemption).then(function () {
                var message = !redemption.isUsed
                    ? "perks.myPerks.markPerkAsUsed.marked.success.message"
                    : "perks.myPerks.markPerkAsUsed.unmarked.success.message";
                notify.success({
                    message: formatMessage({ id: message }, { header: get(redemption, "deal.header") }),
                    position: "top-right"
                });
                _this.setState({ selectedRedemption: null });
            });
        };
        _this.handleArchiveSuccess = function (redemption) {
            var formatMessage = _this.props.formatMessage;
            notify.success({
                message: formatMessage({ id: "perks.myPerks.archive.success.message" }, { header: get(redemption, "deal.header") }),
                position: "top-right"
            });
            removeFromRedemptionList(redemption, _this.variables);
        };
        _this.handleLoadMore = function (isVisible, apollo) {
            if (isVisible) {
                var _a = getRedemptionList(apollo), hasMore = _a.hasMore, cursor = _a.cursor;
                var shouldFetchMore = !apollo.loading && hasMore && cursor;
                if (shouldFetchMore) {
                    return apollo.nextPage(__assign(__assign({}, _this.variables), { cursor: cursor }));
                }
            }
        };
        return _this;
    }
    MyPerksList.prototype.componentDidMount = function () {
        this.selectRedemptionCheck();
    };
    MyPerksList.prototype.selectRedemptionCheck = function () {
        var _this = this;
        var redemptionUuid = get(getQuery(), "redemptionUuid", null);
        if (redemptionUuid) {
            redemptionsService.get(redemptionUuid).then(function (redemption) {
                _this.setState({
                    showRedemptionPopup: true,
                    selectedRedemption: redemption
                });
            });
        }
    };
    Object.defineProperty(MyPerksList.prototype, "variables", {
        get: function () {
            return {
                isUsed: this.props.isUsedPerks
            };
        },
        enumerable: false,
        configurable: true
    });
    MyPerksList.prototype.render = function () {
        var _this = this;
        var isUsedPerks = this.props.isUsedPerks;
        var _a = this.state, selectedRedemption = _a.selectedRedemption, showRedemptionPopup = _a.showRedemptionPopup;
        return (React.createElement(React.Fragment, null,
            React.createElement(React.Fragment, null,
                React.createElement(H1, { marginBottom: 2 },
                    React.createElement(FormattedMessage, { id: isUsedPerks ? "perks.components.myPerks.myPerksPage.used" : "perks.components.myPerks.myPerksPage.new" })),
                React.createElement(Body, { marginBottom: 3 },
                    React.createElement(FormattedMessage, { id: isUsedPerks ? "perks.myPerks.myPerksPage.usedSubHeader" : "perks.myPerks.myPerksPage.newSubHeader" })),
                React.createElement(Hr, null),
                React.createElement(DealRedemptionList, { variables: this.variables, fetchPolicy: "network-only" }, function (apollo) {
                    var results = getRedemptionList(apollo).results;
                    if (results.length === 0) {
                        return React.createElement(NoPerks, { usedPerksOptionActive: isUsedPerks });
                    }
                    return (React.createElement(React.Fragment, null,
                        React.createElement(RedemptionHeaders, null),
                        results.map(function (redemption) { return (React.createElement(MyPerksItem, { key: redemption.uuid, redemption: redemption, onViewRedemption: function () { return _this.viewRedemption(redemption); }, onMarkAsUsed: function () { return _this.handleMarkAsUsedPopup(redemption); }, onArchiveSuccess: function () { return _this.handleArchiveSuccess(redemption); }, usedPerksOptionActive: isUsedPerks })); }),
                        React.createElement(ShowMoreOrThatsAll, { apollo: apollo, onNewPage: _this.handleLoadMore })));
                })),
            selectedRedemption && React.createElement(PerkSummaryPopup, { show: showRedemptionPopup, onHide: this.handleClose, redemption: selectedRedemption }),
            selectedRedemption && !showRedemptionPopup && (React.createElement(MarkPerkAsUsedPopup, { show: true, onHide: this.handleClose, redemption: selectedRedemption, onSubmit: this.handleToggleIsUsed }))));
    };
    return MyPerksList;
}(PureComponent));
export default injectIntl(MyPerksList);
